import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";
import { BillingInformationContext } from "../../../../Account/BillingInformation/BillingInformationContext";
import { usePayment } from "../../../../Account/BillingInformation/Shared/hooks/Payment/usePayment";
import { CheckoutContext } from "../../../../Checkout/CheckoutContext";
import { useOrderFlow } from "../../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { customizeDecrement, customizeIncrement, HandleCustomizeSubmit, } from "../../../../OrderFlow/components/modules/Recipe/RecipeModule-utils";
import { getMustReplaceIngredients } from "../../../../OrderFlow/hooks/RecipeSelection/recipeSelectionUtils";
import { useSession } from "../../../../OrderFlow/hooks/Session/useSession";
import { useCheckRequirements } from "../../../../OrderFlow/hooks/useCheckRequirements";
import { useLogging } from "../../../hooks/useLogging/useLogging";
import { CustomizationContext } from "../../CustomizeModal/CustomizationContext";
import { useModal } from "../../Modal";
import { CartSelectionModeType } from "../OrderSummary.request";
import { handleEditAddClick, handleEditMinusClick, handleUnselectedMealClick, onRecipeClick, saveEdits, } from "./OrderSummaryEdit-utils";
import { OrderSummaryEditContext } from "./OrderSummaryEditContext";
export const useOrderSummaryEdit = () => {
    var _a, _b, _c, _d;
    const { CheckRequirements } = useCheckRequirements();
    // TODO REPLACE AND REMOVE ALL INSTANCES OF AND REFERENCES TO pricingBreakdown WITH EQUIVALENT FROM BALANCE OBJECT
    const { store, dispatch, setPricingBreakdown, setBalance } = useOrderFlow();
    const { showModal, closeModal } = useModal();
    const navigate = useNavigate();
    const location = useLocation();
    const { doesPaymentIntentExist } = useContext(BillingInformationContext);
    const { mealsBeforeEditing, setIsEditMode, setMealsBeforeEditing, isEditMode, setLoading, loading, setIsCustomizeModalOpen, setTemplateBeforeEditing, isCustomizeModalOpen, templateBeforeEditing, recipeId, setRecipeId, date, setDate, resetContext, } = useContext(OrderSummaryEditContext);
    const { assignmentId, isAddDisabled, meals, setMeals, setIsAddDisabled, setQuantity, setAssignmentId } = useContext(CustomizationContext);
    const { setOrderInfo } = useContext(CheckoutContext);
    const { datadogLog } = useLogging();
    const { ContinueToCheckout } = useSession();
    const { updatePayInitiation } = usePayment();
    const currentMeal = store.cart.meals.find((meal) => { var _a; return (_a = meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.find((ra) => ra.AssignmentId === assignmentId); });
    const canAddRemoveMeals = store.model.CartSettings.CartSelectionMode === CartSelectionModeType.CAN_ADD_REMOVE_MEALS;
    const canAddRemoveRecipes = store.model.CartSettings.CartSelectionMode === CartSelectionModeType.CAN_ADD_REMOVE_RECIPES;
    const currentRecipeAssignment = (_a = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.find((ra) => ra.AssignmentId === assignmentId);
    const recipe = store.model.Recipes.find((recipe) => recipe.RecipeId === recipeId);
    const customizeModalProps = {
        cardControlProps: {
            hideControls: false,
            isAddDisabled: isAddDisabled ||
                (!canAddRemoveMeals &&
                    ((_b = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.RecipeAssignments) === null || _b === void 0 ? void 0 : _b.reduce((total, assignment) => total + assignment.Quantity, 0)) ===
                        (currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.Quantity)),
            isCustomizeModal: true,
            isMinusDisabled: false,
            isSingleSelect: false,
            quantity: (_c = currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.Quantity) !== null && _c !== void 0 ? _c : 0,
            setOpen: () => { },
            handleCustomizeIncrement: (shouldSetAssignmentId) => customizeIncrement(canAddRemoveRecipes, canAddRemoveMeals, canAddRemoveMeals, meals, store.model.Program, store.model.DeliveryDays, date, assignmentId, setAssignmentId)(recipe, currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.ProgramMealId, setMeals, setIsAddDisabled, setQuantity)(shouldSetAssignmentId),
            handleCustomizeDecrement: () => customizeDecrement(canAddRemoveRecipes, canAddRemoveMeals, store.model.GeneralSettings.OnlyShowDeliveryDays, store.cart.template, meals, store.cart.daysOfWeek, date, assignmentId)(recipe, currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.ProgramMealId, setMeals, setIsAddDisabled, setQuantity),
        },
        recipe,
        name: (_d = recipe === null || recipe === void 0 ? void 0 : recipe.RecipeName) !== null && _d !== void 0 ? _d : "",
        description: recipe === null || recipe === void 0 ? void 0 : recipe.RecipeDescription,
        displayRecipeDescription: store.model.ProductAndRecipeCardLayoutSettings.DisplayRecipeDescription,
        ingredientsToReplace: getMustReplaceIngredients(recipe).ingredientsToReplace,
        programMealId: currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.ProgramMealId,
        open: isCustomizeModalOpen,
        // date will always be defined in the customize modal
        date: date,
        onClose: () => {
            setIsCustomizeModalOpen(false);
            setRecipeId(undefined);
            setDate(undefined);
        },
        onSubmit: HandleCustomizeSubmit(store.model.Recipes, date, dispatch)(recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId, recipe === null || recipe === void 0 ? void 0 : recipe.ProgramMealId, setMeals),
    };
    return {
        saveEdits: saveEdits(CheckRequirements, showModal, closeModal, navigate, location, store, dispatch, mealsBeforeEditing, setIsEditMode, setMealsBeforeEditing, setOrderInfo, 
        // TODO REPLACE AND REMOVE ALL INSTANCES OF AND REFERENCES TO pricingBreakdown WITH EQUIVALENT FROM BALANCE OBJECT
        setPricingBreakdown, setBalance, datadogLog, ContinueToCheckout, setLoading, updatePayInitiation, doesPaymentIntentExist),
        handleEditMinusClick: handleEditMinusClick(store.cart.meals, store.cart.template, dispatch),
        handleEditAddClick: handleEditAddClick(store.cart.meals, store.cart.template, dispatch),
        handleUnselectedMealClick: handleUnselectedMealClick(store.cart.meals, store.cart.template, dispatch),
        isEditMode,
        loading,
        setIsEditMode,
        mealsBeforeEditing,
        templateBeforeEditing,
        setMealsBeforeEditing,
        setTemplateBeforeEditing,
        setIsCustomizeModalOpen,
        isCustomizeModalOpen,
        resetContext,
        customizeModalProps,
        onRecipeClick: onRecipeClick(store.cart.meals, setMeals, setAssignmentId, setIsCustomizeModalOpen, setRecipeId, setDate),
    };
};
